import { render } from "./HelpItem.vue?vue&type=template&id=1be32842"
import script from "./HelpItem.vue?vue&type=script&lang=js"
export * from "./HelpItem.vue?vue&type=script&lang=js"

import "./HelpItem.vue?vue&type=style&index=0&id=1be32842&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/help/HelpItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1be32842"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1be32842', __exports__)) {
    api.reload('1be32842', __exports__)
  }
  
  module.hot.accept("./HelpItem.vue?vue&type=template&id=1be32842", () => {
    api.rerender('1be32842', render)
  })

}


export default __exports__